import { Component, OnInit,Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { PdfPreviewPage } from 'src/app/modals/files/pdf-preview/pdf-preview.page';

@Component({
  selector: 'app-file',
  templateUrl: './file.page.html',
  styleUrls: ['./file.page.scss'],
})
export class FilePage implements OnInit {
  @Input() file: any;
  @Input() selected_files: any[] = [];
  //When true, only Download / Mark as Important / Cancel are shown (used outside the file explorer, where select/move/copy/delete don't apply)
  @Input() minimal = false;
  //When true, shows a "Go to Folder" option (used in the flat "Important" view, where a file's real folder isn't the one currently open)
  @Input() show_go_to_folder = false;
  //When true, shows a "Preview" option - only set for PDFs (see ExplorerComponent.presentFilePopover)
  @Input() is_pdf = false;

  constructor(private popoverController: PopoverController, private modalController: ModalController) { }

  ngOnInit() {
    console.log("File, ", this.file);
    if (this.file.file_name && this.file.file_name.includes('.pdf')) {
      this.is_pdf = true;
    }
  }

  async PreviewFile() {
    if (!this.is_pdf) return;
    const modal = await this.modalController.create({
      component: PdfPreviewPage,
      componentProps: { file: this.file },
      cssClass: 'large-modal secondary-modal',
      backdropDismiss: true,
    });
    await modal.present();
    this.popoverController.dismiss(null);
  }

  

  async ReturnOption(val) {
    this.popoverController.dismiss(val);
  }

}
